export default {"productFilterSkin1Content":"yyQvf","content":"HLFrQ","title":"_5h4Q9","filter":"FUXlw","quantity":"ZUE8e","quantityTitle":"nnWiI"};